import './assets/style.css';
import { createApp } from 'vue';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import router from './router/';
import VueCookies from 'vue-cookies';
import VueGtag from 'vue-gtag';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { 
  faPhone,
  faLocationDot, 
  faCloudArrowUp,
  faCheck, 
  faXmark,
  faDonate,
  faHouse,
  faSearch
} from '@fortawesome/free-solid-svg-icons';
import { faHeart } from '@fortawesome/free-regular-svg-icons';

library.add(
  faPhone,
  faLocationDot,
  faCloudArrowUp,
  faCheck,
  faXmark,
  faDonate,
  faHeart,
  faHouse,
  faSearch
);

const app = createApp(App);

app.use(router);
app.use(bootstrap);
app.use(VueCookies, { expires: import.meta.env.VITE_COOKIES_EXPIRES });
app.use(VueGtag, {
  config: { id: 'G-J115TVHKSS' }
});

app.component('font-awesome-icon', FontAwesomeIcon);

app.mount('#app');
